/* unplugin-vue-components disabled */import script from "./XCommonDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./XCommonDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__